import { faExclamationTriangle, faTimer } from '@fortawesome/pro-duotone-svg-icons'
import { faCheck, faHourglass, faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

export type OrderProgressStatus = 'success' | 'error' | 'pending' | 'in-progress' | 'excluded'

interface OrderStatusIndicatorProps {
  status: OrderProgressStatus
}

export const OrderStatusIndicator: React.FC<OrderStatusIndicatorProps> = ({ status }) => {
  switch (status) {
    case 'success':
      return (
        <span className="rounded-full p-3 bg-green h-6 flex items-center justify-center gap-2">
          <FontAwesomeIcon icon={faCheck} className="text-white" />
          <span className="text-xs text-white">Úspěch</span>
        </span>
      )
    case 'error':
      return (
        <span className="rounded-full p-3 bg-red h-6 flex items-center justify-center gap-2">
          <FontAwesomeIcon icon={faTriangleExclamation} className="text-white" />
          <span className="text-xs text-white">Chyba</span>
        </span>
      )
    case 'pending':
      return (
        <span className="rounded-full p-3 bg-gray-200 h-6 flex items-center justify-center gap-2">
          <FontAwesomeIcon icon={faTimer} className="text-black" />
          <span className="text-xs text-black">Čekání</span>
        </span>
      )
    case 'in-progress':
      return (
        <span className="rounded-full p-3 bg-cloud-blue h-6 flex items-center justify-center gap-2">
          <div className="loader-nano ease-linear"></div>
          <span className="text-xs text-black">Probíhá</span>
        </span>
      )
    case 'excluded':
      return (
        <span className="rounded-full p-3 bg-gray-200 h-6 flex items-center justify-center gap-2">
          <FontAwesomeIcon icon={faCheck} className="text-black" />
          <span className="text-xs text-black">Vyloučeno</span>
        </span>
      )
    default:
      return (
        <span className="rounded-full p-3 bg-gray h-6 flex items-center justify-center gap-2">
          <FontAwesomeIcon icon={faTimer} className="text-gray-400" />
          <span className="text-xs text-black">Čekání</span>
        </span>
      )
  }
}
